import React from 'react';
import styles from '@/components/countdownClock/CountdownClock.module.scss';

export const Countdown: React.FC<{ days: number; hours: number; minutes: number; t: Function }> = ({
    days,
    hours,
    minutes,
    t,
}) => {
    return (
        <div className={styles.countdownClockContainer}>
            <div data-testid={'timeLeft'}>{t('translations.contest.countdown.left')}</div>
            <div className={styles.countdownClock}>
                <div className={styles.countdownClockElement} data-testid={'days'}>
                    <p className={styles.countdownClockNumber}>{days}</p>
                    <p className={styles.countdownClockDescription}>{t('translations.contest.countdown.days')}</p>
                </div>
                <div className={styles.countdownClockElement} data-testid={'hours'}>
                    <p className={styles.countdownClockNumber}>{hours}</p>
                    <p className={styles.countdownClockDescription}>{t('translations.contest.countdown.hours')}</p>
                </div>
                <div className={styles.countdownClockElement} data-testid={'minutes'}>
                    <p className={styles.countdownClockNumber}>{minutes}</p>
                    <p className={styles.countdownClockDescription}>{t('translations.contest.countdown.minutes')}</p>
                </div>
            </div>
        </div>
    );
};
